/**
 * "just now", "2 min ago", "1 h ago": how long since a list was last fetched.
 * Request of 4 October 2026, section 8. Coarse on purpose; a reader wants to
 * know whether what they see is fresh, not the second it arrived.
 */
export function ago(thenMs: number, nowMs: number): string {
  const seconds = Math.max(0, Math.round((nowMs - thenMs) / 1000));
  if (seconds < 45) return 'just now';
  const minutes = Math.round(seconds / 60);
  if (minutes < 60) return `${minutes} min ago`;
  return `${Math.round(minutes / 60)} h ago`;
}
